var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettingMenu01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#FAF5F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#A97752"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#A97752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.095V11.3741C9 10.8744 9.40529 10.4691 9.90497 10.4691H19.9125C20.4122 10.4691 20.8175 10.8744 20.8175 11.3741V19.095C20.8175 19.5947 20.4122 20 19.9125 20H9.90497C9.40529 20 9 19.5947 9 19.095Z",
    fill: "#A97752",
    stroke: "#FAF5F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.098 11.4731V9.53653C18.098 9.23948 18.3099 9 18.5701 9C18.8303 9 19.0398 9.23948 19.0398 9.53653V11.4731C19.0398 11.7701 18.828 12.0096 18.5678 12.0096C18.3076 12.0096 18.098 11.7701 18.098 11.4731Z",
    fill: "#FAF5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5106 11.4731V9.53653C10.5106 9.23948 10.7225 9 10.9827 9C11.2429 9 11.4524 9.23948 11.4524 9.53653V11.4731C11.4524 11.7701 11.2406 12.0096 10.9804 12.0096C10.7201 12.0096 10.5106 11.7701 10.5106 11.4731Z",
    fill: "#FAF5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.8801H20.8175",
    stroke: "#FAF5F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1816 16.0071L14.3215 17.8631L17.0732 14.7383",
    stroke: "#FAF5F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingMenu01);
export default __webpack_public_path__ + "static/media/icon-setting-menu01.a430864f322bd86a08d5260d1aca469e.svg";
export { ForwardRef as ReactComponent };